import { useEffect } from "react";
import { Button, cn } from "@nextui-org/react";
import { faChevronLeft, faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Breakpoint, useBreakpoint } from "cenero-ui-library";
import logo from "@/assets/images/logo.svg";
import logoMinimal from "@/assets/images/logo_minimal.svg";
import { useSideMenuStore } from "@/store/SideMenuStore";
import { useWindowResizing } from "@/hooks/useWindowResizing";
import ThemeSelector from "../settings/ThemeSelector";
import MenuContents from "./MenuContents";

// ---------------------- Component

const MenuSide = () => {
  // --------- Variables / Hooks

  const breakpoint = useBreakpoint();

  const windowResizing = useWindowResizing();

  const {
    isOpen,
    toggle: toggleMenu,
    setClosed: closeMenu,
    setOpen: openMenu,
  } = useSideMenuStore();

  // --------- Effects

  useEffect(() => {
    if (windowResizing) {
      if (breakpoint === Breakpoint.md) {
        closeMenu();
      } else {
        openMenu();
      }
    }
  }, [breakpoint]);

  // --------- JSX

  return (
    <>
      <div
        className={cn(
          "standard-shadow relative h-full rounded-xl bg-white p-1 transition-[width] duration-500 ease-in-out dark:bg-gray-900",
          isOpen ? "w-40" : "w-16",
        )}
      >
        <div
          className="flex h-full flex-col justify-between rounded-xl border border-gray-50 p-3 dark:border-gray-950"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              toggleMenu();
            }
          }}
        >
          <div>
            {/*******************************************/}
            {/* App Logo */}
            {/*******************************************/}

            <div
              className={cn(
                "ml-[0.1rem] h-8 p-1 transition-[margin] duration-500",
                isOpen && "-ml-2",
              )}
            >
              <img
                alt="Field Service Logo"
                src={isOpen ? logo : logoMinimal}
                className={cn("h-6 transition-opacity duration-300")}
              />
            </div>

            {/*******************************************/}
            {/* Menu Contents */}
            {/*******************************************/}

            <MenuContents />
          </div>

          <div className="item-center flex flex-col justify-start gap-4">
            {/*******************************************/}
            {/* Toggle Menu Button */}
            {/*******************************************/}

            <div className="mx-auto flex size-8 flex-col items-center justify-center rounded-full border border-gray-100 bg-white dark:border-gray-800 dark:bg-gray-900">
              <Button
                isIconOnly
                radius="full"
                className="flex-none bg-transparent p-2 text-current transition-all duration-200"
                onPress={toggleMenu}
              >
                <FontAwesomeIcon
                  icon={isOpen ? faChevronLeft : faChevronRight}
                  className="h-[0.65rem] text-gray-800 dark:text-gray-200"
                />
              </Button>
            </div>

            {/*******************************************/}
            {/* Theme Selector */}
            {/*******************************************/}

            <div className="h-auto w-full">
              <ThemeSelector />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuSide;
